export default {
  addressBook: {
    cancel: 'Cancel',
    row: {
      actions: {
        change: 'Change',
      },
    },
    listView: {
      header: 'Choose Shipping Address',
      submit: 'Use Address',
    },
    createView: {
      header: 'Add a New Shipping Address',
      submit: 'Save & Use Address',
    },
    editView: {
      header: 'Edit Shipping Address',
      submit: 'Save & Use Address',
    },
  },
  shippingAddress: 'Shipping Address',
  cart: {
    startCheckout: 'Proceed to Checkout',
  },
  orderSummary: {
    title: 'Order Summary',
    soldBy: 'Sold by {{shopName}}',
    shipsFrom: 'Ships from {{location}}',
    shippingCost: '{{amount}} Shipping',
  },
  shippingLayout: {
    continueToPayment: 'Continue',
  },
  paymentLayout: {
    continueOnKlarna: 'Continue on Klarna',
  },
};
